// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_ANSWERED_QUESTIONS = ["%(count)s zodpov\u011bzen\u00e1 ot\u00e1zka", "%(count)s zodpov\u011bzen\u00e9 ot\u00e1zky", "%(count)s zodpov\u011bzen\u00fdch ot\u00e1zek"];
export const FORUM_READ_MORE = "\u010cti d\u00e1l...";
export const FORUM_TOPIC_SET_DESCRIPTION_AND_RULES = "Nastav si popis a pravidla f\u00f3ra";
export const num_POSTS_AND_ANSWERS_IN_LAST_WEEK = ["%(num)s \u010dlov\u011bk p\u0159isp\u011bl za t\u00fdden", "%(num)s lid\u00e9 p\u0159isp\u011bli za t\u00fdden", "%(num)s lid\u00ed p\u0159isp\u011blo za t\u00fdden"];
export const SUBSCRIBE_TOPIC = "Odeb\u00edrej";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
export const TOPIC_HEADER_DONT_WANT_TO_BE_SUBSCRIBED = "Nechci odeb\u00edrat";
